// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3765":"335df3fc","4057":"b34defef","4397":"a56c94c9","9925":"c8b141a9"}[chunkId] + ".chunk.css";
};